import React from 'react';
import Typewriter from 'typewriter-effect';

const Type = () => {
  return (
    <Typewriter
      options={{
        strings: [
          'Software Developer Engineer',
          'Android and IOS Developer',
          'Technology Enthusiast',
          'Designer',
          'Video Editor',
          'Efficient Problem Solver'
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  );
};

export default Type;
